import {createI18n} from 'vue-i18n';
import en from '@/libs/locales/en.json';
import it from '@/libs/locales/it.json';
import LocalStorage from '@/libs/Storage';
import {it as itLang, enUS as enLang} from 'date-fns/locale';

let storedLocale = LocalStorage.get('lang');
let defaultLanguage = process.env.VUE_APP_DEFAULT_LANG || 'it';

// Set up the i18n instance with locale messages
const i18n = createI18n({
    locale: storedLocale !== null ? storedLocale : defaultLanguage,   // Default locale
    fallbackLocale: 'en', // Fallback locale
    messages: {
        en,    // English translations
        it     // Italian translations
    }
});

const localeMap = {
    'en': enLang,
    'it': itLang,
}

export function localeToFuncLocale(locale) {
    return localeMap.hasOwnProperty(locale) ? localeMap[locale] : enLang;
}

export default i18n;
